import React, { Fragment, useMemo } from 'react'
import styled from 'styled-components'
import ImportanceHearts from './importance-hearts'
import StatementStatBarSm from './statement-stat-bar-sm'
import StatementStatBar from './statement-stat-bar'
import DriverStatBarSm from './driver-stat-bar-sm'
import DriverStatBar from './driver-stat-bar'
import { map } from 'lodash-es'
import LabelIconCurrentState from '../../images/label-icon-current-state.svg'
import LabelIconImportance from '../../images/label-icon-importance.svg'
import { darkenLightenColor } from '../../utilities/helpers'
import { PHONELG } from '../../utilities/breakpoints'

const ComparativeReportResultRow = ({
  type = "statements",
  barColor,
  label,
  parents,
  result,
  rate,
  showLabels = false,
  useTranslate,
  hideImportance = false
}) => {

  const revParents = useMemo(
    () => [...parents].reverse(),
    [parents]
  );

  const isYouResult = label === useTranslate("data_vault.you") && parents.length === 0;
  const color = isYouResult ? darkenLightenColor(barColor, -50) : barColor;

  if (type === "overall" || type === "themes") {
    result = result === 0 ? null : result;
  }

  return (
    <ParameterResult className="parameter-result">
      {showLabels &&
        <LabelsRow>
          <div />
          <CurrentStateColumn>
            <LabelIcon className="label-icon" src={LabelIconCurrentState} />
            <Label className="label">{useTranslate('data_vault.current_state')}</Label>
          </CurrentStateColumn>
          {!hideImportance &&
            <ImportanceColumn>
              <LabelIcon className="label-icon" src={LabelIconImportance}/>
              <Label className="label">{useTranslate('data_vault.importance')}</Label>
            </ImportanceColumn>
          }
        </LabelsRow>
      }
      <ResultRow className={`${isYouResult ? "you-result" : ""}`}>
        <ParameterTitle>
          <div className="parents">
            {map(revParents, (parent, i) => (
              <span key={i}>{i > 0 ? " - " : ""}{parent}</span>
            ))}
          </div>
          <h5>{label}</h5>
        </ParameterTitle>

        <CurrentStateColumn>
          {result !== null ?
            <Fragment>
              <div className="bar-lg">
                {type === "statements" ?
                  <StatementStatBar result={result} useTranslate={useTranslate} barColor={color} />
                  :
                  <DriverStatBar result={result} useTranslate={useTranslate} barColor={color} />
                }
              </div>
              <div className="bar-sm">
                {type === "statements" ?
                  <StatementStatBarSm result={result} barColor={color} />
                  :
                  <DriverStatBarSm result={result} barColor={color} />
                }
              </div>
              <span className="result">{result.toFixed(0)}%</span>
            </Fragment>
            :
            <span>-</span>
          }
        </CurrentStateColumn>

        {!hideImportance &&
          <ImportanceColumn>
            {rate ?
              <Fragment>
                <ImportanceHearts importance={rate} />
                <span className="result">{rate.toFixed(1)}</span>
              </Fragment>
              :
              <span>-</span>
            }
          </ImportanceColumn>
        }
      </ResultRow>
    </ParameterResult>
  )
}

export default ComparativeReportResultRow;

const ParameterResult = styled.div`
  width: 100%;
  padding: 0 0 12px;
  
  + .parameter-result {
    border-top: 1px solid #E4E7EB;
    padding: 12px 0 12px;
  }
`;

const LabelsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(2, 21%);
  margin-bottom: 5px;
  
  .label {
    display: none;
  }
  
  @media${PHONELG} {
    grid-template-columns: 1fr repeat(2, 150px);
    grid-column-gap: 20px;
    
    .label {
      display: inline;
    }
    .label-icon {
      display: none;
    }
  }
  
  @media (min-width: 1000px) {
    grid-template-columns: 1fr 50% 150px;
    grid-column-gap: 30px;
  }
`;

const ResultRow = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(2, 21%);
  align-items: center;
  
  @media${PHONELG} {
    grid-template-columns: 1fr repeat(2, 150px);
    grid-column-gap: 20px;
  }
  
  @media (min-width: 1000px) {
    grid-template-columns: 1fr 50% 150px;
    grid-column-gap: 30px;
  }
`;

const Label = styled.span`
  display: block;
  font-size: 12px;
  color: #656579;
  margin-bottom: 5px;
`;

const LabelIcon = styled.img``;

const ParameterTitle = styled.div`  
  h5 {
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
  
  .you-result & h5 {
    font-weight: 600;
  }
  
  .parents {
    color: #6E6D79;
    font-size: 12px;
  }
  
  @media${PHONELG} {
    h5 {
      font-size: 16px;
    }
  }
`;


const CurrentStateColumn = styled.div`
  display: flex;
  align-items: center;
  
  .result {
    font-weight: 500;
    font-size: 14px;
  }
  
  .bar-sm {
    display: none;
  }
  
  .bar-lg {
    display: none;
  }
  
  @media${PHONELG} {
    .result {
      font-size: 16px;
      margin-left: 10px;
    }
    
    .bar-sm {
      display: block;
    }
  }
  @media (min-width: 1000px) {
    .result {
      display: none;
    }
    .bar-sm {
      display: none;
    }
    
    .bar-lg {
      display: flex;
      flex: 1 1 100%;
    }
  }
`;

const ImportanceColumn = styled.div`
  display: flex;
  align-items: center;
  
  .importance-hearts {
    display: none;
  }
  
  .result {
    font-weight: 500;
    font-size: 14px;
  }
  
  @media${PHONELG} {
    .importance-hearts {
      display: flex;
    }
    
    .result {
      font-size: 16px;
      margin-left: 10px;
    }
  }
`;




// WEBPACK FOOTER //
// ./src/components/ui/comparative-report-result-row.js